const routes = {
  index: '/lab',
  // follows a root that ends in a slash: /lab/device/upsert/12
  upsert: 'upsert/',
  fax: {
    root: '/fax/',
    send: 'send/',
    incoming: 'incoming/',
    outgoing: 'outgoing/',
  },
  billing: {
    root: '/billing/',
    procedures: 'procedures',
    charge: 'charge',
    paperClaims: 'paper-claims',
    eraFiles: 'era-files',
    eraExceptions: 'era-exceptions',
    needsWork: 'needs-work',
    denials: 'denials',
    pendingStatements: 'pending-statements',
    paperStatements: 'paper-statements',
    analytics: 'analytics',
    kpiScorecard: 'kpi-scorecard',
    reports: 'reports',
    new: '/new/',
    edit: '/edit/',
  },
  order: {
    root: '/order',
    new: '/new/',
    edit: '/orderEdit/',
    newOrder: '/new-order',
    nightOwl: 'nightowl/',
    diagnostic: '/orderDiagnostic/',
    billing: {
      authorization: {
        testType: 'POX_COX_HST',
        bucket: 'AUTHORIZATION',
      },
      billingReview: {
        testType: 'POX_COX_HST',
        bucket: 'BILLING_REVIEW',
      },
      billingHold: {
        testType: 'POX_COX_HST',
        bucket: 'BILLING_HELD',
      },
      billingQueued: {
        testType: 'POX_COX_HST',
        bucket: 'BILLING_QUEUED',
      },
      billingFailed: {
        testType: 'POX_COX_HST',
        bucket: 'BILLING_FAILED',
      },
      billingChargeBlocked: {
        testType: 'POX_COX_HST',
        bucket: 'BILLING_CHARGE_BLOCKED',
      },
      clientBillReview: {
        testType: 'POX_COX_HST',
        bucket: 'CLIENT_BILL_REVIEW',
      },
      billingPendingCharge: {
        testType: 'ALL',
        bucket: 'BILLING_PENDING_CHARGE',
      },
      billingPaperClaims: {
        testType: 'ALL',
        bucket: 'BILLING_PAPER_CLAIMS',
      },
      billingChargesPendingSubmission: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_PENDING_SUBMISSION',
      },
      billingChargesAll: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_ALL',
      },
      billingChargesSubmitted: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_SUBMITTED',
      },
      billingChargesFailedSubmission: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_FAILED_SUBMISSION',
      },
      billingChargesActive: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_ACTIVE',
      },
      billingChargesPaid: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_PAID',
      },
      billingChargesRejected: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_REJECTED',
      },
      billingChargesCobPending: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_COB_PENDING',
      },
      billingChargesCrossedOver: {
        testType: 'ALL',
        bucket: 'BILLING_CHARGES_CROSSED_OVER',
      },
      billingEraFiles: {
        testType: 'ALL',
        bucket: 'BILLING_ERA_FILES'
      },
      billingNeedsWork: {
        testType: 'ALL',
        bucket: 'BILLING_NEEDS_WORK',
      },
      billingDenials: {
        testType: 'ALL',
        bucket: 'BILLING_DENIALS',
      },
      pendingStatements: {
        testType: 'ALL',
        bucket: 'BILLING_PENDING_STATEMENTS',
      },
      paperStatementsReady: {
        testType: 'ALL',
        bucket: 'BILLING_PAPER_STATEMENTS_READY',
      },
    },
    actionItems: {
      directMessages: {
        testType: 'ALL',
        bucket: 'DM',
      },
      demographicVerification: {
        testType: 'POX_COX',
        bucket: 'DEMO_VER',
      },
      insuranceVerification: {
        testType: 'POX_COX',
        bucket: 'INS_VER',
      },
      needAttention: {
        testType: 'POX_COX',
        bucket: 'NEED_ATTENTION',
      },
      awaitingReview: {
        testType: 'POX_COX',
        bucket: 'AWAITING_REVIEW',
      },
    },
    pulseOxCapOx: {
      directMessages: {
        testType: 'ALL',
        bucket: 'DM',
      },
      active: {
        testType: 'POX_COX',
        bucket: 'ACTIVE',
      },
      all: {
        testType: 'POX_COX',
        bucket: 'ALL',
      },
      open: {
        testType: 'POX_COX',
        bucket: 'OPEN',
      },
      demographicVerification: {
        testType: 'POX_COX',
        bucket: 'DEMO_VER',
      },
      insuranceVerification: {
        testType: 'POX_COX',
        bucket: 'INS_VER',
      },
      needAttention: {
        testType: 'POX_COX',
        bucket: 'NEED_ATTENTION',
      },
      awaitingReview: {
        testType: 'POX_COX',
        bucket: 'AWAITING_REVIEW',
      },
      readyToSchedule: {
        testType: 'POX_COX',
        bucket: 'NO_NEW',
      },
      followUp: {
        testType: 'POX_COX',
        bucket: 'NO_FOLLOW_UP',
      },
      needToShip: {
        testType: 'POX_COX',
        bucket: 'NO_NEED_TO_SHIP',
      },
      readyToShip: {
        testType: 'POX_COX',
        bucket: 'NO_READY_TO_SHIP',
      },
      shipped: {
        testType: 'POX_COX',
        bucket: 'NO_SHIPPED',
      },
      delivered: {
        testType: 'POX_COX',
        bucket: 'NO_DELIVERED',
      },
      pendingReturn: {
        testType: 'POX_COX',
        bucket: 'PENDING_RETURN',
      },
      shippedBack: {
        testType: 'POX_COX',
        bucket: 'NO_SHIPPED_BACK',
      },
      deliveredBack: {
        testType: 'POX_COX',
        bucket: 'NO_DELIVERED_BACK',
      },
      completed: {
        testType: 'POX_COX',
        bucket: 'COMPLETED',
      },
      cancelled: {
        testType: 'POX_COX',
        bucket: 'CANCELLED',
      },
      failedFaxes: {
        testType: 'ALL',
        bucket: 'FAILED_FAXES',
      },
      pendingFaxes: {
        testType: 'ALL',
        bucket: 'PENDING_FAXES',
      },
    },
    hst: {
      open: {
        testType: 'HST',
        bucket: 'OPEN',
      },
      demographicVerification: {
        testType: 'HST',
        bucket: 'DEMO_VER',
      },
      insuranceVerification: {
        testType: 'HST',
        bucket: 'INS_VER',
      },
      paperworkVerification: {
        testType: 'HST',
        bucket: 'HST_PAPERWORK_VERIFICATION',
      },
      pendingOfficeNotes: {
        testType: 'HST',
        bucket: 'HST_PENDING_OFFICE_NOTES',
      },
      officeNotesVerification: {
        testType: 'HST',
        bucket: 'HST_OFFICE_NOTES_VERIFICATION',
      },
      needAttention: {
        testType: 'HST',
        bucket: 'NEED_ATTENTION',
      },
      awaitingReview: {
        testType: 'HST',
        bucket: 'AWAITING_REVIEW',
      },
      orderVerification: {
        testType: 'HST',
        bucket: 'HST_VERIFICATION',
      },
      patientConsent: {
        testType: 'HST',
        bucket: 'HST_PATIENT_CONSENT',
      },
      preAuthorization: {
        testType: 'HST',
        bucket: 'AUTHORIZATION',
      },
      patientScheduling: {
        testType: 'HST',
        bucket: 'HST_PATIENT_SCHEDULING',
      },
      deviceShipping: {
        testType: 'HST',
        bucket: 'HST_DEVICE_SHIPPING',
      },
      readyToSchedule: {
        testType: 'HST',
        bucket: 'NO_NEW',
      },
      followUp: {
        testType: 'HST',
        bucket: 'NO_FOLLOW_UP',
      },
      needToShip: {
        testType: 'HST',
        bucket: 'NO_NEED_TO_SHIP',
      },
      readyToShip: {
        testType: 'HST',
        bucket: 'NO_READY_TO_SHIP',
      },
      shipped: {
        testType: 'HST',
        bucket: 'NO_SHIPPED',
      },
      delivered: {
        testType: 'HST',
        bucket: 'NO_DELIVERED',
      },
      pendingReturn: {
        testType: 'HST',
        bucket: 'PENDING_RETURN',
      },
      shippedBack: {
        testType: 'HST',
        bucket: 'NO_SHIPPED_BACK',
      },
      deliveredBack: {
        testType: 'HST',
        bucket: 'NO_DELIVERED_BACK',
      },
      patientTesting: {
        testType: 'HST',
        bucket: 'HST_PATIENT_TESTING',
      },
      pendingReport: {
        testType: 'HST',
        bucket: 'HST_PENDING_REPORT',
      },
      wesperReview: {
        testType: 'HST',
        bucket: 'HST_WESPER_REVIEW',
      },
      retestPending: {
        testType: 'HST',
        bucket: 'HST_RETEST_PENDING',
      },
      followUpCare: {
        new: {
          testType: 'HST',
          bucket: 'FOLLOW_UP_CARE_NEW',
        },
        sent: {
          testType: 'HST',
          bucket: 'FOLLOW_UP_CARE_SENT',
        },
        confirmed: {
          testType: 'HST',
          bucket: 'FOLLOW_UP_CARE_CONFIRMED',
        },
      },
      completed: {
        testType: 'HST',
        bucket: 'COMPLETED',
      },
      cancelled: {
        testType: 'HST',
        bucket: 'CANCELLED',
      },
      failedFaxes: {
        testType: 'HST',
        bucket: 'FAILED_FAXES',
      },
      pendingFaxes: {
        testType: 'HST',
        bucket: 'PENDING_FAXES',
      },
      all: {
        testType: 'HST',
        bucket: 'ALL',
      },
    },
    psg: {
      open: {
        testType: 'PSG',
        bucket: 'OPEN',
      },
      demographicVerification: {
        testType: 'PSG',
        bucket: 'DEMO_VER',
      },
      insuranceVerification: {
        testType: 'PSG',
        bucket: 'INS_VER',
      },
      needAttention: {
        testType: 'PSG',
        bucket: 'NEED_ATTENTION',
      },
      awaitingReview: {
        testType: 'PSG',
        bucket: 'AWAITING_REVIEW',
      },
      orderVerification: {
        testType: 'PSG',
        bucket: 'PSG_VERIFICATION',
      },
      patientConsent: {
        testType: 'PSG',
        bucket: 'PSG_PATIENT_CONSENT',
      },
      preAuthorization: {
        testType: 'PSG',
        bucket: 'AUTHORIZATION',
      },
      patientScheduling: {
        testType: 'PSG',
        bucket: 'PSG_PATIENT_SCHEDULING',
      },
      patientScheduled: {
        testType: 'PSG',
        bucket: 'PSG_PATIENT_SCHEDULED',
      },
      followUpCare: {
        new: {
          testType: 'PSG',
          bucket: 'FOLLOW_UP_CARE_NEW',
        },
        sent: {
          testType: 'PSG',
          bucket: 'FOLLOW_UP_CARE_SENT',
        },
        confirmed: {
          testType: 'PSG',
          bucket: 'FOLLOW_UP_CARE_CONFIRMED',
        },
      },
      completed: {
        testType: 'PSG',
        bucket: 'COMPLETED',
      },
      cancelled: {
        testType: 'PSG',
        bucket: 'CANCELLED',
      },
      failedFaxes: {
        testType: 'PSG',
        bucket: 'FAILED_FAXES',
      },
      pendingFaxes: {
        testType: 'PSG',
        bucket: 'PENDING_FAXES',
      },
      all: {
        testType: 'PSG',
        bucket: 'ALL',
      },
    },
  },
  ticket: {
    root: '/ticket/',
  },
  device: {
    root: '/device/',
  },
  // TES-3191: its own path, so Device Management is not highlighted with it
  accessoryReplacement: {
    root: '/accessory-replacement/',
  },
  catalog: {
    root: '/catalog/',
  },
  physician: {
    root: '/physician',
    directory: '/directory',
    upsert: '/',
  },
  deviceImport: {
    root: '/deviceImport/',
  },
  fileType: {
    root: '/fileType/',
  },
  file: {
    root: '/file/',
  },
  deviceType: {
    root: '/deviceType/',
  },
  deviceCategory: {
    root: '/deviceCategory/',
  },
  deviceTypeLink: {
    root: '/deviceTypeLink/',
  },
  brand: {
    root: '/brand/',
  },
  ticketType: {
    root: '/ticketType/',
  },
  ticketTopic: {
    root: '/ticketTopic/',
  },
  company: {
    root: '/company/',
  },
  physicianGroups: {
    root: '/physician-groups/',
  },
  region: {
    root: '/region/',
  },
  office: {
    root: '/office/',
  },
  patient: {
    root: '/patient',
    directory: '/directory',
    moveReport: '/move-report/',
    editReportConditions: '/edit-report-conditions/',
    mergePatients: '/merge-patients/',
  },
  payer: {
    root: '/payors/',
  },
  dmePayer: {
    root: '/dme-payors/',
  },
  payerChargeRules: {
    root: '/charge-rules/',
  },
  status: {
    root: '/status/',
  },
  labUsers: {
    root: '/users/',
    directory: 'directory/',
  },
  dmeUsers: {
    root: '/dme-users/',
    directory: 'directory/',
  },
  physicianGroupUsers: {
    root: '/physician-group-users/',
    directory: 'directory/',
  },
  bulletins: {
    root: '/bulletins/',
    directory: 'directory/',
  },
  tags: {
    root: '/tags/',
    directory: 'directory/',
  },
  retellOutboundSettings: {
    root: '/retell-outbound-settings/',
  },
  billingSettings: {
    root: '/billing-settings/',
  },
  readerAppSettings: {
    root: '/reader-app-settings/',
  },
  retellOutboundActivity: {
    root: '/retell-outbound-activity/',
  },
  reports: {
    root: '/reports/',
    stats: 'stats',
    analytics: 'analytics',
    patientAging: 'patient-aging',
    followUpCare: 'follow-up-care',
    preferenceSetup: 'preference-setup',
    auditTrail: 'audit-trail',
    productivity: 'productivity',
    bankDeposit: 'bank-deposit',
    writeOffs: 'write-offs',
  },
  v1Archive: {
    root: '/v1-archive/',
  },
}

export default routes
